export default __webpack_public_path__ + "static/media/login-background.9e470faa.png";